var React = require('react');

function DropdownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 -4.86374e-05L0 4.99995L0.7 5.69995L5 1.39995L9.3 5.69995L10 4.99995L5 -4.86374e-05Z","fill":"currentColor"}));
}

DropdownInline.defaultProps = {"width":"10","height":"6","viewBox":"0 0 10 6","fill":"none"};

module.exports = DropdownInline;

DropdownInline.default = DropdownInline;
